import BaseAccountController from '../../lib/controllers/BaseAccountController';

declare var LtFramework: lt.Static;

export default class RecurringServicesController extends BaseAccountController {
	public static $inject: string[] = ['$q', '$timeout', '$scope', 'UserResource', 'MembershipResource', 'RecurringProductResource'];

	public user: MyAccountApi.IUser;
	public memberId: number;
	public generalError: string;
	public generalMessage: string;
	public magazineOptIn: boolean;
	public prevMagazineOptIn: boolean;
	public membership: MyAccountApi.IMembership;
	public recurringServices: ng.resource.IResourceArray<MyAccountApi.IRecurringProduct>;

	private readonly $q: ng.IQService;
	private readonly $timeout: ng.ITimeoutService;
	private readonly User: MyAccountApi.IUserResource;
	private readonly MembershipResource: MyAccountApi.IMembershipResource;
	private readonly RecurringProductResource: MyAccountApi.IRecurringProductResource;

	constructor($q: ng.IQService, $timeout: ng.ITimeoutService, $scope: ng.IScope, User: MyAccountApi.IUserResource,
			MembershipResource: MyAccountApi.IMembershipResource, RecurringProductResource: MyAccountApi.IRecurringProductResource) {
		super($scope);

		this.$q = $q;
		this.$timeout = $timeout;
		this.User = User;
		this.MembershipResource = MembershipResource;
		this.RecurringProductResource = RecurringProductResource;

		// clear messages if the user changes the opt-in status
		$scope.$watch('ctrl.magazineOptIn', () => {
			this.generalError = '';
			this.generalMessage = '';
		});
	}

	public changeExperienceLifeOptIn(): void {
		this.generalError = '';
		this.generalMessage = '';

		// show loading indicator
		this.recurringServices = new Array<MyAccountApi.IRecurringProduct>() as ng.resource.IResourceArray<MyAccountApi.IRecurringProduct>;
		this.recurringServices.$resolved = false;

		this.RecurringProductResource.optInExperienceLife({magazineOptIn: this.magazineOptIn}, () => {
			this.prevMagazineOptIn = this.magazineOptIn;

			if (this.magazineOptIn) {
				this.generalMessage = 'You are now subscribed to the Experience Life magazine';
			} else {
				this.generalMessage = 'You are now unsubscribed from the Experience Life magazine';
			}

			// reload recurring services. Need to wait a few seconds since the opt in call returns before the recurring product is added
			this.$timeout(() => {
				this.recurringServices = this.RecurringProductResource.query();
			}, 5000);
		}, () => {
			this.generalError = 'Server error while changing magazine subscription preference';

			// hide loading indicator
			this.recurringServices.$resolved = true;
		});
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		this.user = this.User.get();
		this.membership = this.MembershipResource.get(() => {
			// commPrefs.magazine reflects opt-out status, so true means opted out
			this.magazineOptIn = this.prevMagazineOptIn = !this.membership.commPrefs.magazine;
		});
		this.$q.all([this.user.$promise, this.membership.$promise]).then(() => {
			this.memberId = this.user.memberContext.memberId;
			this.recurringServices = this.RecurringProductResource.query({memberId: this.memberId});
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
